"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var ActionWithSymbol = require('../actionWithSymbol');

var calendarSymbol = require('../icons/calendar.svg.js');

var dateUtil = require('../../util/date');

var displayNames = require('../displayNames');

var DatePicker = require('../datePicker');

var ContextMenu = require('../contextMenu');

var DatePickerInput = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePickerInput, _React$Component);

  var _super = _createSuper(DatePickerInput);

  function DatePickerInput(props) {
    var _this;

    _classCallCheck(this, DatePickerInput);

    _this = _super.call(this, props);

    _this.getCustomButton = function () {
      var isValidDate = dateUtil.isValid(_this.props.value);
      var children = isValidDate ? _this.props.value.toLocaleDateString() : _this.props.translateIfNeeded(_this.props.placeholder);
      return React.createElement(ActionWithSymbol, {
        symbol: React.createElement(calendarSymbol),
        initialized: isValidDate
      }, children);
    };

    return _this;
  }

  _createClass(DatePickerInput, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.getClassName('control-date-picker-input'),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement(ContextMenu, {
        className: "context-menu-block",
        alignment: "BOTTOM",
        direction: "MIDDLE",
        customButton: this.getCustomButton()
      }, /*#__PURE__*/React.createElement(DatePicker, {
        value: this.props.value,
        onChange: this.props.onChange
      })));
    }
  }]);

  return DatePickerInput;
}(React.Component);

DatePickerInput.displayName = displayNames.DATE_PICKER_INPUT;
DatePickerInput.propTypes = {
  /** Placeholder to show when no date is selected */
  placeholder: PropTypes.string.isRequired,

  /** On date change callback */
  onChange: PropTypes.func.isRequired,

  /** Date value */
  value: PropTypes.object
};
module.exports = compose(DatePickerInput);